export default __webpack_public_path__ + "static/media/8s.30237c16.svg";